import { UseQueryOptions } from 'react-query';

import {
  PortalConnection,
  usePortalConnectionByIndex,
} from 'bones/utils/portal/usePortalConnectionByIndex';

export const usePortalDashboardUrl = (
  connectionIdx: number,
  options?: UseQueryOptions<PortalConnection | null>
): string | null =>
  usePortalConnectionByIndex(connectionIdx, options).data?.dashboard || null;
